import React, { useEffect, useMemo, useState } from 'react';

const COLORS = ['#f43f5e', '#f59e0b', '#facc15', '#22c55e', '#06b6d4', '#3b82f6', '#a855f7', '#ec4899'];

// A one-shot confetti shower over the whole screen. Hidden for reduced-motion users (CSS).
const Confetti: React.FC<{ pieces?: number }> = ({ pieces = 90 }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 4500);
    return () => clearTimeout(t);
  }, []);

  const bits = useMemo(() => Array.from({ length: pieces }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    color: COLORS[i % COLORS.length],
    w: 6 + Math.random() * 8,
    h: Math.random() < 0.3 ? 6 + Math.random() * 8 : 10 + Math.random() * 10,
    round: Math.random() < 0.3,
    style: {
      '--drift': `${(Math.random() - 0.5) * 240}px`,
      '--spin': `${(Math.random() - 0.5) * 1440}deg`,
      '--dur': `${2.2 + Math.random() * 1.8}s`,
      '--delay': `${Math.random() * 0.6}s`,
    } as React.CSSProperties,
  })), [pieces]);

  if (!visible) return null;
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-50" aria-hidden="true">
      {bits.map(b => (
        <span key={b.id} className="fun-confetti-piece"
          style={{ ...b.style, left: `${b.left}%`, width: b.w, height: b.h, background: b.color, borderRadius: b.round ? '9999px' : '2px' }} />
      ))}
    </div>
  );
};

export default Confetti;
